import { render } from "./SCMagazine.vue?vue&type=template&id=50e2497d"
import script from "./SCMagazine.vue?vue&type=script&lang=js"
export * from "./SCMagazine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__